module.exports = __webpack_public_path__ + "static/media/vote-btn-hover.79a15804.png";